// 引入拖拽js
import { startDrag } from '../common/drag.js'

/**
 * 为el-dialog弹框增加拖拽功能
 * @param {*} el 指定dom
 * @param {*} binding 绑定对象
 * desc   只要用到了el-dialog的组件，都可以通过增加v-draggable属性变为可拖拽的弹框
 */
let draggable = {}
draggable.install = function (Vue) {
  Vue.directive('draggable', {
    bind: function (el, binding) {
      try {
        // 绑定拖拽事件 [绑定拖拽触发元素为弹框头部、拖拽移动元素为整个弹框]
        startDrag(el.querySelector('.el-dialog__header'), el, binding.value)
      } catch (e) {
        console.info('drag', e)
      }
    }
  })
}
export default draggable
